// extracted by mini-css-extract-plugin
module.exports = {"cart-item":"CartItem_cart-item__3WLhv","summary":"CartItem_summary__2s6Ch","price":"CartItem_price__2RSIb","amount":"CartItem_amount__vVovy","actions":"CartItem_actions__13r0u"};